<template>
  <el-form class="form form__outbox-attachments" ref="form" @submit.native.prevent="onSubmit()">

    <p v-if="formattedAssets.length === 0">
      {{ $t('outboxNoAttachments') }}
    </p>

    <expander v-for="productFamily in formattedAssets" :key="productFamily.id" removable
      @remove="removeProduct(productFamily.id)">

      <span class="attachment__headline" slot="headline">
        <el-checkbox :class="{ 'semi-selected': productFamily.someSelected }" @change="toggleAllAssets([productFamily])"
          v-model="productFamily.allSelected">
          {{ productFamily.familyDisplay }}
        </el-checkbox>
      </span>

      <div class="collections" v-for="collection in productFamily.allAttachableAssets" :key="collection.id">
        <span class="collection__heading">
          {{ collection.heading }}
        </span>
        <div class="configuration__checkboxes">
          <div class="configuration__checkbox" v-for="asset in collection.media" :key="asset.id">
            <el-checkbox @change="toggleAssetSelection([productFamily.id, asset.id])" v-model="asset.isSelected">
              {{ asset.title }}
            </el-checkbox>
          </div>
        </div>
      </div>

    </expander>
  </el-form>
</template>

<script>
import outbox from '@/components/outbox';
import { mapActions, mapGetters, mapState } from 'vuex';
import Expander from '@/components/Expander.vue';

export default {
  name: 'OutboxAttachments',
  computed: {
    ...mapState(outbox.store.namespace, [
      'assets'
    ]),
    ...mapGetters(outbox.store.namespace, [
      'formattedAssets'
    ]),
  },
  methods: {
    onSubmit() {
      // Todo: Make this do something...
    },
    ...mapActions(outbox.store.namespace, [
      'removeProduct'
    ]),
    ...mapActions(outbox.store.namespace, [
      'toggleAssetSelection',
      'toggleAllAssets'
    ])
  },
  components: {
    Expander
  }
}
</script>

<style lang="scss" scoped></style>
